import { ShieldX } from 'lucide-react';
import { Link } from 'react-router-dom';

function AccessDeniedPage() {
  return (
    <div className="grid min-h-screen place-items-center bg-surface-page p-5 text-center">
      <div>
        <span className="mx-auto grid size-12 place-items-center rounded-full bg-danger-50 text-danger-600"><ShieldX className="size-6" /></span>
        <h1 className="mt-4 text-2xl font-semibold text-content-primary">Acceso denegado</h1>
        <p className="mt-2 text-sm text-content-muted">Tu rol no cuenta con permisos para acceder a esta sección.</p>
        <Link to="/dashboard" className="mt-6 inline-flex text-sm font-semibold text-primary-700 hover:text-primary-800">Volver al dashboard</Link>
      </div>
    </div>
  );
}

export default AccessDeniedPage;
